import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { data } from 'jquery';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);

        this.state = {
            collapsed: true,
            data: null
        };
    }

    componentDidMount() {
        this.loadMenu();
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    toggleActiveChild() {
        if (document.querySelectorAll('.nav-item .colapsable')) {

            document.querySelectorAll('.nav-item .colapsable').forEach((a, i) => {
                a.addEventListener('mouseenter', function () {
                    this.parentElement.querySelector('ul').classList.add('active')
                });

                a.parentElement.addEventListener('mouseleave', function () {
                    this.querySelector('ul').classList.remove('active')
                })
            });
        }
    }

    async loadMenu() {

        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        const response = await fetch('Menu/Get', request);
        if (response.status === 200) {
            const data = await response.json();

            this.setState({ data: data });
        }
        this.toggleActiveChild();

    }

    isHome(aditionalClass) {
        return window.location.href.substring(window.location.href.lastIndexOf('/'), window.location.href.length).length < 2 ? `nav-link text-white ${aditionalClass}` : `nav-link text-dark ${aditionalClass}`;
    }

    static renderMenuAdmin(context) {
        return (
            <header>
                <input type="hidden" id="sesionAdmin" />
                <input type="hidden" id="appRol" value={context.state.data.roles.join(',')} />
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <a className={context.isHome()} href="/"><img src={require('../icon/LogoLife.png')} style={{ width: 60 }} /></a>
                        <NavbarToggler onClick={context.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!context.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <a className={context.isHome()} href="/">Inicio</a>
                                <li className="nav-item">
                                    <a class={context.isHome('colapsable')}>Formularios</a>

                                    <ul className="nav-child">
                                        <li className="nav-item">
                                            <a className="nav-item" href="/registro">Registro</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-basico">Ficha b&aacute;sico</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-avanzado">Ficha avanzado</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-pl">Ficha pl</a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a class={context.isHome('colapsable')}>Administrador</a>

                                    <ul className="nav-child">
                                        <li className="nav-item">
                                            <a href="/administrar-procesos">Administrar procesos</a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="/administrar-pqr">Administrar Pqr</a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="/usuarios-registrados">Usuarios registrados</a>
                                        </li>
                                        {
                                            context.state.data && context.state.data.roles.find((e) => { return e == 'Administrador' }) ?
                                                <li className="nav-item"><a className="nav-item" href="/financiero">Financiero</a></li> : null
                                        }

                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/tareas">Tareas</a>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/nuestro-entrenamiento">Nuestros entrenamientos</a>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/comunidad">Ir a la comunidad</a>
                                </li>
                                <li className="nav-item">
                                    <a class={context.isHome('colapsable')} href="#">Mi sesi&oacute;n</a>

                                    <ul className="nav-child">
                                        <li className="nav-item">Hola {context.state.data.firstName}</li>
                                        <li className="nav-item"><a onClick={() => { localStorage.clear('token'); window.Location.href = '/'; context.setState({ data: null }) }} href="#">Cerrar sesi&oacute;n</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>);
    }

    static renderMenuNormal(context) {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <a className={context.isHome()} href="/"><img src={require('../icon/LogoLife.png')} style={{ width: 60 }} /></a>
                        <NavbarToggler onClick={context.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!context.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <a className={context.isHome()} href="/">Inicio</a>
                                <li className="nav-item">
                                    <a class={context.isHome('colapsable')}>Formularios</a>

                                    <ul className="nav-child">
                                        <li className="nav-item">
                                            <a className="nav-item" href="/registro">Registro</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-basico">Ficha b&aacute;sico</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-avanzado">Ficha avanzado</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-item" href="/ficha-pl">Ficha pl</a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/pqr">Formulario de PQR</a>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/nuestro-entrenamiento">Nuestros entrenamientos</a>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/comunidad">Ir a la comunidad</a>
                                </li>
                                <li className="nav-item">
                                    <a className={context.isHome()} href="/iniciar-sesion">Iniciar sesi&oacute;n</a>
                                </li>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }

    render() {

        let content = this.state.data && (this.state.data.roles.find((e) => { return e == 'Oficina' }) || this.state.data.roles.find((e) => { return e == 'Administrador' }) || this.state.data.roles.find((e) => { return e == 'Director' })) ?
            NavMenu.renderMenuAdmin(this) : NavMenu.renderMenuNormal(this);

        return (<div>{content}</div>)
    }
}
